import { lazy } from "react";
import Loadable from "components/Loadable";

const DocumentByDates = Loadable(lazy(() => import("../DocumentByDates")));
// Define lazy-loaded components
const DocumentList = Loadable(lazy(() => import("../DocumentList")));
const FormatListByMonth = Loadable(lazy(() => import("../FormatListByMonth")));
const FormatListByYear = Loadable(lazy(() => import("../FormatListByYear")));
const FormatList = Loadable(lazy(() => import("../FormatList")));
const AddFormat = Loadable(lazy(() => import("../AddFormat")));
const ViewById = Loadable(lazy(() => import("../ViewById")));

// Define routes using lazy-loaded components
const FormatRoute = [
  {
    path: "format",
    children: [
      { path: "list", element: <FormatList /> },
      { path: "by-year/:moduleName", element: <FormatListByYear /> },
      { path: "by-month/:moduleName/:year", element: <FormatListByMonth /> },
      { path: "by-month/:moduleName/:year/:month", element: <DocumentList /> },
      {
        path: "by-date/:moduleName/:year/:month/:documentName",
        element: <DocumentByDates />,
      },
      { path: "add", element: <AddFormat /> },
      { path: ":id", element: <ViewById /> },
    ],
  },
];

export default FormatRoute;
